import { IconButton } from "../../components/IconButton";

interface Props {
  isShiftBlockAssigned: boolean;
  onClick: () => void;
}

export function CancelShiftBlockIconButton(props: Props) {
  const { isShiftBlockAssigned, onClick } = props;

  if (!isShiftBlockAssigned) {
    return null;
  }

  return (
    <IconButton
      variant="ghost"
      iconType="ellipsis"
      size="small"
      aria-label="Cancel block"
      sx={{
        paddingRight: 0,
      }}
      onClick={onClick}
    />
  );
}
